import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["notification"];
  static values = {
    greetingKey: String
  }

  connect() {
    // Check if the notification has already been shown
    if (localStorage.getItem('speechNotificationShown') === 'true') {
      this.hideNotification();
    }
    // Otherwise, the notification remains visible
  }

  hideNotification() {
    this.notificationTarget.remove();
  }

  playVoice(key) {
    if (!window.voiceMap) {
      console.error("voiceMap is not defined; speech notification audio is unavailable");
      return;
    }

    const audioUrl = window.voiceMap[key];
    if (audioUrl) {
      const audio = new Audio(audioUrl);
      audio.play().catch(e => console.error("Audio play failed:", e));
    } else {
      console.error("No audio for key:", key);
    }
  }

  playAndHide() {
    if (this.hasGreetingKeyValue) {
      this.playVoice(this.greetingKeyValue);
    }
    this.hideNotification();
    // Mark as shown to prevent future displays
    localStorage.setItem('speechNotificationShown', 'true');
  }
}